import { render } from "./Justificacion2025.vue?vue&type=template&id=486ba4e3&scoped=true&ts=true"
import script from "./Justificacion2025.vue?vue&type=script&lang=ts"
export * from "./Justificacion2025.vue?vue&type=script&lang=ts"

import "./Justificacion2025.vue?vue&type=style&index=0&id=486ba4e3&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486ba4e3"]])

export default __exports__